module.exports = __webpack_public_path__ + "img/recognition.7bbf67ab.svg";